import { Component, computed, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { ToastModule } from 'primeng/toast';
import { IdleService } from './core/services/idle.service';
import { SessionService } from './core/services/session.service';
import { SessionNoticeComponent } from './shared/components/session-notice/session-notice.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, ToastModule, SessionNoticeComponent],
  templateUrl: './app.component.html',
  styles: [],
})
export class AppComponent {
  private idle    = inject(IdleService);
  private session = inject(SessionService);

  /** Difiere la carga del diálogo hasta que realmente haya que avisar al usuario. */
  readonly hasSessionNotice = computed(() => this.session.pendingNotice() !== null);

  constructor() {
    this.idle.start();
  }
}
